import util from '@/util'
import tableMixin from '@/mixins/tableMixin'
import ShiftTimeRowsMixin from '../../shifts/mixins/ShiftTimeRowsMixin'
import { AUTH_DISCIPLINARY_ACTIONS } from '@/store/modules/shifts/constants'

export default {
  mixins: [ShiftTimeRowsMixin, tableMixin],
  data() {
    return {
      AUTH_DISCIPLINARY_ACTIONS,
      columns: [
        {
          title: 'Shift #', dataIndex: 'shift.id', key: 'shiftId', width: 100,
          sorter: (a, b) => a.shift.id - b.shift.id, originalIndex: 0
        },
        {
          title: 'Associate', key: 'associate', width: 250, scopedSlots: { customRender: 'associate' },
          sorter: (a, b) => {
            const aName = util.combineAssociateName(a.associate.first_name, a.associate.last_name)
            const bName = util.combineAssociateName(b.associate.first_name, b.associate.last_name)
            return aName == null ? -1 : bName == null ? 1 : aName.localeCompare(bName)
          }, originalIndex: 1
        },
        {
          title: 'Scheduled', key: 'scheduled', width: 200,
          sorter: (a, b) => this.sortDate(a.shift.scheduled_start, b.shift.scheduled_start),
          customRender: (_, record) => this.getCollectedDate(record.shift, 'scheduled_', record.authorizations.filter(item => item.status === 'initial').map(item => item.type)), originalIndex: 2
        },
        {
          title: 'Tracked', key: 'actual', width: 200,
          sorter: (a, b) => this.sortDate(a.shift.actual_work_start, b.shift.actual_work_start),
          customRender: (_, record) => this.getCollectedDate(record.shift, 'actual_', record.authorizations.filter(item => item.status === 'initial').map(item => item.type)), originalIndex: 3
        },
        {
          title: 'Signed', key: 'signed', width: 200,
          sorter: (a, b) => this.sortDate(a.shift.work_start, b.shift.work_start),
          customRender: (_, record) => this.getCollectedDate(record.shift, '', record.authorizations.filter(item => item.status === 'initial').map(item => item.type)), originalIndex: 4
        },
        { title: 'Violations', key: 'authorizations', width: 300, scopedSlots: { customRender: 'authorizations' }, sorter: (a, b) => a.authorizations.length - b.authorizations.length, originalIndex: 5 },
        { title: 'Actions', key: 'actions', width: 100, scopedSlots: { customRender: 'actions' }, originalIndex: 6 }
      ]
    }
  },
  methods: {
    sortDate(a, b) {
      const dateA = a ? new Date(a) : null
      const dateB = b ? new Date(b) : null
      if (!dateA && !dateB) return 0
      if (!dateA) return 1
      if (!dateB) return -1
      return dateA - dateB
    }
  }
}
